<template>
    <div class="login_form">
        {{ form.info }}
        <div class="login_form--phone" v-if="activeForm === 'phone'">
            <form @submit.prevent="sendPhone">
                <input
                    type="text"
                    placeholder="+7 906 999 99 99"
                    v-model.trim="form.phone"
                >
                <button type="submit" class="btn btn-full" :class="{disabled: isDisabledBtn}">
                    Далее
                </button>

                <div class="login_form--agree" v-html="this.agreeText">
                </div>
            </form>
        </div>

        <div class="login_form--code" v-if="activeForm === 'code'">
            <form v-if="authType !== 'call_gate'" @submit.prevent="checkAuth">
                <div class="hint">
                    <p>{{ authType === 'call_password' ? 'Введите последние 4 цифры входящего звонка на номер:' : 'СМС код отправлен на номер:' }}</p>
                    <b>{{ form.phone }}</b>
                </div>
                <div class="code_inputs">
                    <split-input
                        v-model="form.code"
                        class-name="code_input"
                        :input-number="4"
                        type="tel"
                    />
                </div>
                <button
                    class="btn btn-full"
                    :class="{disabled: this.form.code.toString().length !== 4 || isDisabledBtn === true}"
                    :disabled="this.form.code.toString().length !== 4 || isDisabledBtn === true"
                >
                    Далее
                </button>
                <div class="hint">
                    <b>Не пришел код?</b>
                    <p v-if="send_again === false">Повторная отправка через: {{ timer }} сек</p>

                    <p v-if="send_again === true" @click="sendPhone">Отправить еще раз</p>
                </div>
            </form>
            <div v-if="authType === 'call_gate'">
              <div class="hint">
                <p>Для регистрации необходимо совершить бесплатный звонок на номер</p>
                <b>{{ phoneToCall }}</b>
              </div>
              <a :href="'tel:' + phoneToCall" class="btn btn-full">
                Позвонить
              </a>
              <div class="hint call-gate-check">
                <p>Ничего не произошло?</p>
                <a @click="checkAuth" class="main-color"><b>Проверить сессию</b></a>
              </div>
            </div>
        </div>

        <div class="login_form--registration" v-if="activeForm === 'registration'">
            <form @submit.prevent="createUser">
                <input
                    placeholder="Имя"
                    v-model="form.name"
                >
                <input
                    placeholder="Фамилия"
                    v-model="form.surname"
                >
                <Datepicker
                        v-model="form.birth_date"
                        modelType="yyyy-MM-dd"
                        placeholder="Дата рождения"
                        format="dd.MM.yyyy"
                        locale="ru"
                        cancelText=""
                        selectText="Применить"
                        :enableTimePicker="false"
                        :disabledDates="(date) => date >= new Date()"
                >
                </Datepicker>

                <button class="btn btn-full" :class="{disabled: isDisabledBtn}">
                    Зарегистрироваться
                </button>
            </form>
        </div>

        <div class="login_form--errors">
            <ul>
                <li v-for="error in form.errors" :key="error">
                    {{ error }}
                </li>
            </ul>
        </div>

    </div>
</template>

<script>
    import Datepicker from '@vuepic/vue-datepicker';
    import '@vuepic/vue-datepicker/dist/main.css'

    export default {
        name: "AuthForm",
        components: { Datepicker },
        data() {
            return {
                activeForm: 'phone',
                info: null,
                form: {
                    phone : '',
                    code : '',
                    surname : '',
                    name : '',
                    birth_date : '',
                },
                errors: [],
                need_client: false,
                token: '',
                timer: 60,
                send_again: false,
                isDisabledBtn: false,
                phoneToCall: null,
                callGateId: null,
                checkCallGateAuthInterval: null,
            }
        },
        computed: {
            authType: function () {
                try {
                    return this.$store.getters.settings.modules.auth.type
                }catch (e) {
                    return ''
                }
            },
            agreeText: function () {
                try {
                    let settings = this.$store.getters.settings.modules;

                    let clubRules = settings.club_rules;
                    let offer = settings.offer;
                    let personalData = settings.processing_personal_data;
                    let links = [];

                    if (personalData.enable === true && personalData.link !== ''){
                        links.push('<a href="' + personalData.link + '" target="_blank">Персональных данных</a>')
                    }else{
                        links.push('<a href="https://fitbase.io/privacy" target="_blank">Персональных данных</a>')
                    }

                    if (offer.enable === true && offer.link !== ''){
                        links.push('<a href="' + offer.link + '" target="_blank">Офертой</a>')
                    }

                    if (clubRules.enable === true && clubRules.link !== ''){
                        links.push('<a href="' + clubRules.link + '" target="_blank">Правилами клуба</a>')
                    }

                    return 'Продолжая, вы соглашаетесь с обработкой ' + links.join(', ') + '.';
                }catch (e) {
                    return ''
                }
            },
        },
        watch: {
            'form.code'() {
                const inputs = document.querySelectorAll('.code_input')
                inputs.forEach(item => {
                    item.classList.remove('active')

                    if (item.value !== ''){
                        item.classList.add('active')
                    }
                })

                if (this.form.code.toString().length === 4){
                    this.checkAuth();
                }
            }
        },
        methods: {
            async sendPhone(){
                this.isDisabledBtn = true
                this.errors = []
                if (this.authType !== 'call_gate') {
                  try {
                      const data = (await this.$api.auth.auth({
                          phone: this.form.phone
                      })).data;

                      if (data.status === 'code send'){
                          this.activeForm = 'code';

                          this.send_again = false
                          this.countDownTimer()
                      }

                      this.errorHandler(data)
                  }catch (error) {
                      this.errorHandler(error)
                  }
                } else {
                  try {
                    const data = (await this.$api.auth.authCallGate({
                      phone: this.form.phone
                    })).data;

                    if (data.success){
                      this.activeForm = 'code';
                      this.phoneToCall = data.result.phone;
                      this.callGateId = data.result.id;

                      this.checkCallGateAuthInterval = setInterval(() => {
                        this.checkAuth();
                      }, 5000);
                    }

                    this.errorHandler(data)
                  }catch (error) {
                    this.errorHandler(error)
                  }
                }
            },
            async checkAuth(){
                this.isDisabledBtn = true
                this.errors = []
                try {
                    let data;
                    if (this.authType !== 'call_gate') {
                      data = (await this.$api.auth.auth({
                        phone: this.form.phone,
                        code: this.form.code,
                      })).data;
                    } else {
                      data = (await this.$api.auth.checkAuthCallGate({
                        phone: this.form.phone,
                        integration_id: this.callGateId,
                      })).data;
                    }

                    if (data.status === 'authorize'){
                        if (this.checkCallGateAuthInterval) {
                          clearInterval(this.checkCallGateAuthInterval);
                        }

                        this.token = data.token;
                        localStorage.setItem('fitbase_token', data.token)

                        // Нужен ли клиент
                        this.need_client = Boolean(data.no_client);

                        if (this.need_client){
                               this.activeForm = 'registration'
                        }else{
                            this.$store.commit('SET_TOKEN', this.token)
                            this.$router.push({ name: 'Home' })
                        }
                    }

                    this.errorHandler(data)
                }catch (error) {
                    this.errorHandler(error)
                }
            },
            async createUser(){
                this.isDisabledBtn = true
                this.errors = []
                try {
                    const data = (await this.$api.auth.registration({
                        name: this.form.name,
                        surname: this.form.surname,
                        patronymic: '',
                        b_day: this.form.birth_date,
                        phone: this.form.phone,
                        club: 1
                    })).data;

                    if (data.id !== undefined && data.id !== null){
                        this.$store.commit('SET_TOKEN', this.token)
                        this.$router.push({ name: 'Home' })
                    }

                    this.errorHandler(data)
                }catch (error) {
                    this.errorHandler(error)
                }
            },
            errorHandler(data){
                if (data.error){
                    this.form.errors = data.error;
                }else if (data.response !== undefined && data.response.status !== 200){
                    this.form.errors = new Array(data.response.data.message);
                }
                this.isDisabledBtn = false
            },
            countDownTimer () {
                if (this.timer > 0) {
                    setTimeout(() => {
                        this.timer -= 1
                        this.countDownTimer()
                    }, 1000)
                }else{
                    this.send_again = true
                    this.timer = 300
                }
            }
        }
    }
</script>